module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bi-5adb744e68bc13f75956296eb29398a7.svg";